// templates/WordTemplate.jsx
import React from "react";
import { wordInvoiceData } from "../data/WordInvoiceData";

const WordTemplate = () => {
  const invoice = wordInvoiceData;

  return (
    <div className="bg-white p-6 text-gray-800 font-sans mx-auto max-w-4xl shadow-sm">
      
      {/* Header */}
      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="text-xl font-bold text-gray-800">{invoice.companyName}</h1>
          <p className="text-xs text-gray-600 leading-tight">{invoice.companyAddress}</p>
          <p className="text-xs text-gray-600">GSTIN: {invoice.companyGSTIN}</p>
        </div>
        <div className="text-right">
          <h2 className="text-3xl font-bold uppercase text-gray-800 tracking-tight">Invoice</h2>
          <p className="text-sm font-bold mt-1">Invoice #: {invoice.invoiceNumber}</p>
          <p className="text-sm">Date: {invoice.date}</p>
        </div>
      </div>

      {/* Client Info */}
      <div className="mb-4">
        <p className="text-xs font-bold text-gray-400 uppercase mb-1">Bill To:</p>
        <p className="font-medium text-gray-800">{invoice.clientName}</p>
        <p className="text-xs text-gray-600">{invoice.clientAddress}</p>
      </div>

      {/* Items Table */}
      <table className="w-full text-xs border-collapse mb-4">
        <thead>
          <tr className="bg-gray-100 font-bold uppercase text-gray-700 text-left">
            <th className="py-1 px-2 w-6">#</th>
            <th className="py-1 px-2">Description</th>
            <th className="py-1 px-2 text-right w-12">Qty</th>
            <th className="py-1 px-2 text-right w-20">Rate (₹)</th>
            <th className="py-1 px-2 text-right w-24">Amount (₹)</th>
          </tr>
        </thead>
        <tbody>
          {invoice.items.map((item, idx) => (
            <tr key={item.id} className="border-b border-gray-200">
              <td className="py-1 px-2 text-gray-600">{idx + 1}</td>
              <td className="py-1 px-2 font-medium text-gray-800">{item.desc}</td>
              <td className="py-1 px-2 text-right">{item.qty}</td>
              <td className="py-1 px-2 text-right">{item.rate.toLocaleString()}</td>
              <td className="py-1 px-2 text-right font-bold">{item.amount.toLocaleString()}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Totals */}
      <div className="flex justify-end text-xs mt-4 space-y-1 flex-col w-64">
        <div className="flex justify-between">
          <span className="text-gray-500 font-medium">Subtotal</span>
          <span className="font-bold">{invoice.subtotal.toLocaleString()}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-500 font-medium">GST ({invoice.taxRate}%)</span>
          <span className="font-bold">{invoice.taxAmount.toLocaleString()}</span>
        </div>
        <div className="flex justify-between border-t border-gray-300 pt-1 font-bold text-gray-800">
          <span>Total</span>
          <span>{invoice.total.toLocaleString()}</span>
        </div>
        <div className="flex justify-between bg-gray-100 p-1 font-bold">
          <span>Balance Due</span>
          <span>{invoice.balanceDue.toLocaleString()}</span>
        </div>
      </div>

      {/* Footer */}
      <p className="text-[10px] italic mt-4 text-gray-500">
        Thank you for your business. Please make the payment within 30 days.
      </p>
    </div>
  );
};

export default WordTemplate;
